import React, { useState } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { TabBottomLine, TabWrapper, Heading, BorderBottom,ScrollableContainer } from '../RecogntionAdmin/styles';
import { Table } from '../common/commonStyles';
import { ImageUrl } from "../../utils/constants";
import BarChart from '../common/Manager/BarChart';
import { generateDummyData } from '../../utils/methods';
import { AdminInsightsIcon } from '../../utils/icons';

const Insights = ({ getColor }) => {
  const [activeTab, setActiveTab] = useState('Managers');
  const [showTopRecogntion, setShowTopRecogntion] = useState(false);
  const [showEliteRecogntion, setShowEliteRecogntion] = useState(false);
  const [showEmployeeTopRecogntion, setShowEmployeeTopRecogntion] = useState(false);
  const [showEmployeeEliteRecogntion, setShowEmployeeEliteRecogntion] = useState(false);
  const displayedTopDepartments = showTopRecogntion ? generateDummyData(15) : generateDummyData(15).slice(0, 5);

  const displayedEliteDepartments = showEliteRecogntion ? generateDummyData(15) : generateDummyData(15).slice(0, 5);

  const toggleShowTopRecognition = () => {
    setShowTopRecogntion(!showTopRecogntion);
  };

  const toggleShowEmployeeTopRecognition = () => {
    setShowEmployeeTopRecogntion(!showEmployeeTopRecogntion);
  };


  const toggleShowEliteRecognition = () => {
    setShowEliteRecogntion(!showEliteRecogntion);
  };

  const toggleShowEmployeeEliteRecognition = () => {
    setShowEmployeeEliteRecogntion(!showEmployeeEliteRecogntion);
  };

  const managerView = () => (
    <>
      <BarChart total={802} widthType={"full"} data={generateDummyData(10)} id={"top"} heading={"Top 10 Performing Managers | Overall"} barColor={"#BDDDC2"} circleColor={"#418856"} circleBorderColor={"#91C49D"} totalText="Total Challenges"/>
      <Heading isMargin={"20px 0px 20px 0px"}>
        <div className='icon'>
          {AdminInsightsIcon()}
        </div>
          Woliba Insights
      </Heading>
      <div className='top-performing' style={{display:"block"}}>
        <Table padding="8px 0" insight>
          <div className="heading">Most Engaged in Activity Challenges</div>
          <div className="type">
            <div className="name">Managers</div>
            <div className="value">Challenges</div>
          </div>
          <ScrollableContainer
            height={showTopRecogntion ? "380px" : "330px"}
            showAllRows={showTopRecogntion}
          >
            {displayedTopDepartments.map((data, index) => (
              <div className="item" key={index}>
                <div className="profile">
                  <img src={ImageUrl + "/" + data.image} alt={"profile-image"} />
                </div>
                <div className="name">{data.name}</div>
                <div className="value">{data.value}</div>
              </div>
            ))}
          </ScrollableContainer>
          {generateDummyData(15)?.length > 5 && !showTopRecogntion && (
            <div className="showmore">
              <div className="button" onClick={toggleShowTopRecognition}>
                Show More
              </div>
            </div>
          )}
        </Table>

      </div>
      <div className='low-performing' style={{display:"block"}}>
        <Table padding="8px 0" insight>
          <div className="heading">Most Engaged in Wellness Challenges</div>
          <div className="type">
            <div className="name">Managers</div>
            <div className="value">Challenges</div>
          </div>
          <ScrollableContainer
            height={showEliteRecogntion ? "380px" : "330px"}
            showAllRows={showEliteRecogntion}
          >
            {displayedEliteDepartments.map((data, index) => (
              <div className="item" key={index}>
                <div className="profile">
                  <img src={ImageUrl + "/" + data.image} alt={"profile-image"} />
                </div>
                <div className="name">{data.name}</div>
                <div className="value">{data.value}</div>
              </div>
            ))}
          </ScrollableContainer>
          {generateDummyData(15)?.length > 5 && !showEliteRecogntion && (
            <div className="showmore">
              <div className="button" onClick={toggleShowEliteRecognition}>
                Show More
              </div>
            </div>
          )}
        </Table>
        
      </div>
      <BarChart total={350} widthType={"full"} data={generateDummyData(10)} heading={"Managers Requiring Improvement"} style={{marginTop:"20px"}} barColor={"#EEB3B4"} circleColor={"#C13D4D"} circleBorderColor={"#E4888C"} totalText="Total Challenges"/>
    </>
  )

  const emlpoyeeView = () => (
    <>
      <BarChart total={250} widthType={"full"} data={generateDummyData(10)} id={"top"} heading={"Top 10 Performing Employees | Overall"} barColor={"#D3DEF2"} circleColor={"#8391D1"} circleBorderColor={"#B9C8E8"} totalText="Total Challenges"/>
      <Heading isMargin={"20px 0 20px 0"}>
        <div className='icon'>
          {AdminInsightsIcon()}
        </div>
          Woliba Insights
      </Heading>

      <div className='top-performing' style={{display:"block"}}>
        <Table padding="8px 0" insight>
          <div className="heading">  Most Engaged in Activity Challenges</div>
          <div className="type">
            <div className="name">Employees</div>
            <div className="value">Challenges</div>
          </div>
          <ScrollableContainer
            height={showEmployeeTopRecogntion ? "380px" : "330px"}
            showAllRows={showEmployeeTopRecogntion}
          >
            {displayedTopDepartments.map((data, index) => (
              <div className="item" key={index}>
                <div className="profile">
                  <img src={ImageUrl + "/" + data.image} alt={"profile-image"}/>
                </div>
                <div className="name">{data.name}</div>
                <div className="value">{data.value}</div>
              </div>
            ))}
          </ScrollableContainer>
          {generateDummyData(15)?.length > 5 && !showEmployeeTopRecogntion && (
            <div className="showmore">
              <div className="button" onClick={toggleShowEmployeeTopRecognition}>
                Show More
              </div>
            </div>
          )}
        </Table>
      </div>
      <div className='low-performing' style={{display:"block"}}>
        <Table padding="8px 0" insight>
          <div className="heading">Most Engaged in Wellness Challenges</div>
          <div className="type">
            <div className="name">Employees</div>
            <div className="value">Challenges</div>
          </div>
          <ScrollableContainer
            height={showEmployeeEliteRecogntion ? "380px" : "330px"}
            showAllRows={showEmployeeEliteRecogntion}
          >
            {displayedEliteDepartments.map((data, index) => (
              <div className="item" key={index}>
                <div className="profile">
                  <img src={ImageUrl + "/" + data.image} alt={"profile-image"} />
                </div>
                <div className="name">{data.name}</div>
                <div className="value">{data.value}</div>
              </div>
            ))}
          </ScrollableContainer>
          {generateDummyData(15)?.length > 5 && !showEmployeeEliteRecogntion && (
            <div className="showmore">
              <div className="button" onClick={toggleShowEmployeeEliteRecognition}>
                Show More
              </div>
            </div>
          )}
        </Table>
      </div>
      <BarChart total={760} widthType={"full"} data={generateDummyData(10)} heading={"Employees Requiring Improvement"} style={{marginTop:"20px"}} barColor={"#EEB3B4"} circleColor={"#C13D4D"} circleBorderColor={"#E4888C"} totalText="Total Challenges"/>
    </>
  )

  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <TabWrapper>
          <TabBottomLine active={activeTab === 'Managers'} background={getColor} onClick={() => setActiveTab('Managers')}>
          Managers
            <BorderBottom active={activeTab === 'Managers'} background={getColor} />
          </TabBottomLine>
          <TabBottomLine active={activeTab === 'Employees'} background={getColor} onClick={() => setActiveTab('Employees')}>
          Employees
            <BorderBottom active={activeTab === 'Employees'} background={getColor} />
          </TabBottomLine>
        </TabWrapper>
        {activeTab === "Managers" ?  managerView() : null}
        {activeTab === "Employees" ?  emlpoyeeView() : null}
      </TopContainerWrapper>
    </MainContainer>
  );
};

Insights.propTypes = {
  getColor: PropTypes.func.isRequired,
  selectedFilter:PropTypes.string
};

export default Insights;